// extracted by mini-css-extract-plugin
export var lightMode = "_1e-0";